import { makeStyles } from "tss-react/mui";
import { SCROLL_BAR_STYLES_THIN } from "../Theme";

export const SX_FORM_BUTTONS = {
  fontWeight: 500,
  padding: "0.6em 1em",
  marginBottom: 1,
  width: "50%",
};

// Dialog action buttons: the left one cancels, the right one submits. Colours
// come from AppButton intents; these only place the pair.
export const SX_FORM_CANCEL = { ...SX_FORM_BUTTONS, marginLeft: 3 };
export const SX_FORM_SUBMIT = { ...SX_FORM_BUTTONS, marginRight: 3 };

export const SX_CONTROLLED_AUTOCOMPLETE_SIZE = {
  "& .MuiAutocomplete-inputRoot": {
    flexWrap: "nowrap",
    height: 40,
    overflowX: "auto",
    overflowY: "hidden",
  },
  "& .MuiAutocomplete-tag": {
    maxWidth: 120,
    minWidth: 0,
  },
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

export const formInputsStyles = makeStyles()((theme) => ({
  paper: {
    "& .MuiPaper-root": {
      backgroundColor: theme.vars.palette.background.dialog,
    },
  },
  root: {
    paddingTop: "8px",
    flexWrap: "wrap",
  },
  rootMargin: {
    marginTop: "10px",
    flexWrap: "wrap",
  },
  container: {
    margin: theme.spacing(1),
  },
  inputText: {
    "& .MuiInputBase-root": {
      backgroundColor: theme.vars.palette.background.input,
    },
    "& .MuiInputLabel-root, & .MuiPickersInputLabel-root": {
      fontSize: "0.8125rem",
      "& svg": {
        fontSize: "0.938rem",
      },
    },
    "& .MuiInputLabel-root:not(.Mui-focused), & .MuiPickersInputLabel-root:not(.Mui-focused)":
      {
        color: theme.vars.palette.text.secondary,
      },
    "& input, & .MuiPickersSectionList-root": {
      fontSize: "0.875rem",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink, & .MuiPickersInputLabel-outlined.MuiPickersInputLabel-shrink":
      {
        transform: "translate(0px, -20px)",
        fontWeight: 700,
      },
    "& .MuiInputBase-root .MuiInputBase-input:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${theme.vars.palette.background.input} inset`,
    },
    "&.MuiFormControl-root, &.MuiPickersTextField-root": {
      width: "100%",
    },
    "& .Mui-disabled": {
      color: "text.disabled",
    },
  },
  checkbox: {
    color: theme.vars.palette.text.secondary,
    "& .Mui-checked svg": {
      fill: theme.vars.palette.primary.main,
    },
    "& span": {
      fontSize: "0.812rem",
      fontWeight: 700,
    },
    "&.error": {
      "& span": {
        color: theme.vars.palette.error.main,
      },
      "& svg": {
        fill: theme.vars.palette.error.main,
      },
    },
    "& .Mui-disabled": {
      color: "text.disabled",
    },
  },
  select: {
    "& .MuiInputBase-root": {
      backgroundColor: theme.vars.palette.background.input,
    },
    "& .MuiInput-underline:before": {
      content: "unset",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(0px, -20px)",
      fontWeight: 700,
    },
    "& .MuiInputLabel-root": {
      color: theme.vars.palette.text.secondary,
      fontSize: "0.8125rem",
      "& svg": {
        fontSize: "0.938rem",
      },
    },
    "& input": {
      fontSize: "0.875rem",
    },
    "& .MuiSelect-select": {
      fontSize: "0.875rem",
      height: "0px",
    },
    "& .MuiSelect-icon, & .MuiIconButton-root": {
      color: theme.vars.palette.text.secondary,
    },
    "& .Mui-disabled, & .Mui-disabled button.Mui-disabled": {
      color: "text.disabled",
    },
  },
  errorText: {
    color: theme.vars.palette.error.main,
  },
  nancieText: {
    color: theme.vars.palette.nancie.main,
  },
  warningText: {
    color: theme.vars.palette.warning.main,
  },
  inputSize: {
    flex: "1 1 100%",
  },
  toggleSection: {
    fontSize: "0.812rem",
  },
  contrastContainer: {
    margin: 0,
    gap: "calc(var(--mui-spacing) * 1.5)",
    "& .MuiInputBase-root": {
      backgroundColor: theme.vars.palette.background.input,
      borderRadius: "6px !important",
    },
  },
  scrollbar: SCROLL_BAR_STYLES_THIN,
  connectivityInputReversed: {
    "& .MuiInputBase-root": {
      backgroundColor: theme.vars.palette.background.default,
    },
  },
}));
